import { Rate as RateAntd } from "antd";
import styled from "styled-components";

export const Rate = styled(RateAntd)`
  margin-right: 10px;
`;

interface ILandingHeaderContainerProps {
  hasReviews: boolean;
  difficulty: string;
}

export const LandingHeaderContainer = styled.div<ILandingHeaderContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 32px 50px;
  background: ${({ theme }) => theme.colors.headerBackgroundColor};

  @media (min-width: 990px) {
    margin-top: 4rem;
  }

  .centralizer {
    display: flex;
    justify-content: center;

    width: 100%;
    max-width: 1600px;
  }

  .width-limiter {
    display: flex;
    justify-content: flex-end;

    width: 100%;
    max-width: 1800px;
    min-height: 200px;

    > div {
      width: 100%;
      max-width: 64%;
      margin-bottom: 25px;
      padding-left: 0;
      padding-right: 0;
    }
  }

  h2 {
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 6px;
  }

  h4 {
    font-size: 20px;
    font-weight: 300;
    text-align: start;
    margin-bottom: 10px;
  }

  && {
    .header-title,
    .header-subtitle,
    .header-userinfo,
    .header-reviews,
    .difficulty-section * {
      color: ${({ theme }) => theme.colors?.headerTextColor} !important;
    }
  }

  .header-avatar-initials {
    height: 1.5rem;

    div {
      height: inherit;
      width: inherit;
    }

    h1 {
      font-size: 0.6rem;
    }
  }

  .reviews-and-difficulty {
    width: 100%;
    display: flex;
    margin-top: 7px;
    margin-bottom: 15px;
    align-items: center;
  }

  .difficulty-section {
    display: flex;
    margin-top: 5px;
    align-items: center;
    ${({ hasReviews }) => hasReviews && "margin-left: 20px;"}

    h4 {
      margin: 0;
      font-size: 15px;
      font-weight: 400;
    }

    p {
      margin: 1px 0 0;
      font-size: 14px;
    }

    p::first-letter {
      text-transform: uppercase;
    }

    div {
      width: 14px;
      height: 14px;
      margin: 0 7px 0;
      border-radius: 50%;
      border: 2px solid #fff;
      background: ${({ difficulty }) =>
        difficulty === "Beginner"
          ? "yellowgreen"
          : difficulty === "Intermediate"
          ? "royalblue"
          : "red"};
    }
  }

  @media screen and (max-width: 768px) {
    padding: 22px 16px 60px;
  }

  @media screen and (max-width: 576px) {
    padding: 22px 5px 60px;
  }

  @media (max-width: 800px) {
    .width-limiter {
      justify-content: flex-start;

      > div {
        max-width: 100%;
      }
    }
  }

  @media screen and (max-width: 480px) {
    .reviews-and-difficulty {
      flex-direction: column;
      align-items: flex-start;
    }

    .difficulty-section {
      margin-top: 15px;
      margin-left: 0;
    }
  }
`;
